/**
 * Represents the available types of API instances in the application.
 *
 * @remarks
 * This enum is used to distinguish between different API instance types
 * such as Datastream, Enterprise.
 *
 * @enum {number}
 */
export enum InstanceType {
  Datastream = 0,
  Enterprise = 1,
}
